import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCloseSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-141">
      <div className="container mx-auto px-4 md:px-6" data-id="element-142">
        <div className="max-w-4xl mx-auto text-center" data-id="element-143">
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 font-serif" data-id="element-144">
            You Deserve to Smile Again
          </h2>

          <div className="prose prose-lg mx-auto text-gray-600 mb-12" data-id="element-145">
            <p data-id="element-146">
              If you've been silently struggling with loose dentures… avoiding
              meals, hiding your smile, feeling less like yourself… Dentafix™
              may be the simplest, most life-changing solution you've ever
              tried.
            </p>
            <p className="font-bold text-gray-900 text-xl" data-id="element-147">
              Don't let another day go by feeling uncomfortable in your own
              mouth. You deserve comfort. You deserve confidence. You deserve
              Dentafix™.
            </p>
          </div>

          <div className="mb-12" data-id="element-148">
            <img src="https://images.unsplash.com/photo-1581579438747-104c53d7fbc4?w=800&q=80" alt="Joyful senior smiling" className="w-full max-w-2xl mx-auto h-64 md:h-96 object-cover rounded-2xl shadow-2xl" data-id="element-149" />
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-150">
            <CTAButton text="Yes — I Want Secure Dentures Again" size="xl" pulse={true} data-id="element-151" />

            <p className="text-lg md:text-xl text-gray-700 font-medium max-w-xl mt-2 italic" data-id="element-152">
              "You're not just buying denture glue — you're buying confidence to
              eat, laugh, and smile again without fear."
            </p>

            <p className="text-red-600 font-medium animate-pulse mt-2" data-id="element-153">
              ⚡ High demand worldwide — order today with free shipping.
            </p>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-100 text-gray-400 text-sm" data-id="element-154">
            <p data-id="element-155">
              © 2026 Dentafix™ | All Rights Reserved | 90-Day Smile Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}